import React from 'react';
import { UserIcon } from '@twilio-paste/icons/cjs/UserIcon';
import { Heading } from '@twilio-paste/core/heading';

interface AvatarProps {
  givenName: string;
  familyName: string;
  email: string;
}

export const UserIconWithInfo = ({
  givenName,
  familyName,
  email
}: AvatarProps) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',

        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '64px',
          height: '64px',
          backgroundColor: '#FAF7FD',
          borderRadius: '50%'
        }}
      >
        <UserIcon decorative size={'sizeIcon80'} color={'colorTextUser'} />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '24px'
        }}
      >
        <Heading as="div" variant="heading50" marginBottom="space0">
          <span
            style={{ fontWeight: 700 }}
          >{`${givenName} ${familyName}`}</span>
        </Heading>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            marginTop: '1px'
          }}
        >
          <Heading as="div" variant="heading50" marginBottom="space0">
          <span
            style={{ fontWeight: 700 }}
          >{'Username: '}</span>
            <span style={{ fontWeight: 400 }}>{email}</span>
          </Heading>
        </div>
      </div>
    </div>
  );
};
